import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

export const getProcurements = createAsyncThunk(
  "getprocurements",
  async (status) => {
    try {
      const token = localStorage.getItem("cu_user");
      const { data } = await axios.get(
        `${process.env.REACT_APP_API_HOST}/api/procurement?status=${status}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      return data.data;
    } catch (error) {}
  }
);

export const getProcurementById = createAsyncThunk(
  "getProcurementsById",
  async (procurementId) => {
    try {
      const token = localStorage.getItem("cu_user");
      const { data } = await axios.get(
        `${process.env.REACT_APP_API_HOST}/api/procurement/${encodeURIComponent(
          procurementId
        )}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return data.data;
    } catch (error) {}
  }
);

export const approveProcurement = createAsyncThunk(
  "approveProcurement",
  async ({ id, values }) => {
    return toast.promise(
      new Promise(async (resolve, reject) => {
        try {
          const token = localStorage.getItem("cu_user");
          let response = await axios.patch(
            `${process.env.REACT_APP_API_HOST}/api/procurement/approve/${id}`,
            values,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          if (response.data.status === "success") {
            resolve(response);

            return response?.data;
          } else {
            reject(response?.data?.message);
          }
        } catch (error) {
          reject(error?.response?.data);
        }
      }),
      {
        pending: "Approving...",
        success: "Procurement Approved Successfully!",
        error: {
          render({ data }) {
            return `Procurement Approved Successfully!`;
          },
        },
      }
    );
  }
);

export const rejectProcurement = createAsyncThunk(
  "rejectProcurement",
  async ({ id, values }) => {
    return toast.promise(
      new Promise(async (resolve, reject) => {
        try {
          const token = localStorage.getItem("cu_user");
          let response = await axios.patch(
            `${process.env.REACT_APP_API_HOST}/api/procurement/reject/${id}`,
            values,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          if (response.data.status === "success") {
            resolve(response);

            return response?.data;
          } else {
            reject(response?.data?.message);
          }
        } catch (error) {
          reject(error?.response?.data);
        }
      }),
      {
        pending: "Approving...",
        success: "Procurement Rejected Successfully!",
        error: {
          render({ data }) {
            return `Procurement Rejected Successfully!`;
          },
        },
      }
    );
  }
);

export const getCountsForProcurements = createAsyncThunk(
  "getCountsForProcurements",
  async () => {
    try {
      const token = localStorage.getItem("cu_user");
      const { data } = await axios.get(
        `${process.env.REACT_APP_API_HOST}/api/procurement/agg-status/count`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return data.data;
    } catch (error) {
      console.error(error);
    }
  }
);

export const ProcurementApprovalSlice = createSlice({
  name: "procurementApproval",
  initialState: {
    allProcurements: [],
    procurement: null,
    counts: null,
    status: "idle",
    error: null,
    isloading: true,
  },
  reducers: {},
  extraReducers: {
    [getProcurements.pending]: (state, action) => {
      state.status = "pending";
      state.isloading = true;
    },
    [getProcurements.fulfilled]: (state, action) => {
      state.allProcurements = action.payload;
      state.status = "success";
      state.isloading = false;
    },
    [getProcurements.rejected]: (state, action) => {
      state.status = "rejected";
      state.error = action.error;
      state.isloading = true;
    },
    [getProcurementById.pending]: (state, action) => {
      state.status = "pending";
      state.isloading = true;
    },
    [getProcurementById.fulfilled]: (state, action) => {
      state.status = "success";
      state.procurement = action.payload;
      state.isloading = false;
    },
    [getProcurementById.rejected]: (state, action) => {
      state.status = "rejected";
      state.error = action.error;
      state.isloading = true;
    },
    [getCountsForProcurements.pending]: (state, action) => {
      state.status = "pending";
      state.isloading = true;
    },
    [getCountsForProcurements.fulfilled]: (state, action) => {
      state.status = "success";
      state.counts = action.payload;
      state.isloading = false;
    },
    [getCountsForProcurements.rejected]: (state, action) => {
      state.status = "rejected";
      state.error = action.error;
      state.isloading = true;
    },
  },
});

export default ProcurementApprovalSlice.reducer;
